/* eslint-disabled */
import Prospect from "./Prospect";
import AdditionalInfo from "./AdditionalInfo";
import UniqProspect from "./UniqProspect";
import CompanyExtend from "@/entity/extends/CompanyExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Company extends CompanyExtend {

public id!: number;
public name = '';
public sector? = '';
public email? = '';
public number? = '';
public employees: Array<Prospect> = [];
public additionalInfos: Array<AdditionalInfo> = [];
public uniqProspects: Array<UniqProspect> = [];
public localisation? = '';
public size? = '';
public identifier? = '';
public membersNumber? = '';
public manager? = '';

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.name= object.name;
       this.sector= object.sector;
       this.email= object.email;
       this.number= object.number;
            hydrateCollection(object.employees, Prospect, this.employees);
            hydrateCollection(object.additionalInfos, AdditionalInfo, this.additionalInfos);
            hydrateCollection(object.uniqProspects, UniqProspect, this.uniqProspects);
       this.localisation= object.localisation;
       this.size= object.size;
       this.identifier= object.identifier;
       this.membersNumber= object.membersNumber;
       this.manager= object.manager;
      }
      this.postConstruct()
  }

}

